import CreateBulkEntities from '../CreateBulkEntities'

const CreateBulkVpa = () => {
  return <CreateBulkEntities type="bulkVpa" />
}
export default CreateBulkVpa
